import { QuestDetailsPage } from 'components/quests/quest-details-page';

export default function ChallengeDetailsPage() {
  return <QuestDetailsPage />;
}
